'use es6';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isAppAuthSelector } from 'pricing-pages-unified-ui/selectors/ConfigSelectors';

const EnvironmentWrapper = ({
  authedNode,
  publicNode,
  isAppAuth
}) => {
  return isAppAuth ? authedNode : publicNode;
};

const mapStateToProps = state => ({
  isAppAuth: isAppAuthSelector(state)
});

EnvironmentWrapper.propTypes = {
  authedNode: PropTypes.node,
  publicNode: PropTypes.node,
  isAppAuth: PropTypes.bool.isRequired
};
EnvironmentWrapper.defaultProps = {
  authedNode: null,
  publicNode: null
};
export default connect(mapStateToProps)(EnvironmentWrapper);